import React from "react";
import { IGridItemProps } from "./GridItem.interface";
import {
  GridItemBody,
  GridItemContainer,
  GridItemFooter,
  GridItemHeader,
} from "./GridItem.styled";
import { Paragraph, Subtitle, Title } from "components/Text";
import { Button } from "components/Button/Button.styled";

const GridItem = (props: IGridItemProps) => {
  const { data, children, onClick, actions } = props;

  if (data == null || data === undefined) {
    return (
      <GridItemContainer
        title="grid-item"
        className={props.className + " card-organization"}
      >
        {children}
        {actions && actions.length > 0 ? (
          <GridItemFooter className="card-footer">
            {actions.length > 0 &&
              actions.map((action) => (
                <Button
                  key={action.label}
                  className="btn"
                  onClick={() => action.onClick(data)}
                >
                  {action.label}
                  {action.icon && (
                    <i
                      title="button-icon"
                      className={`cl ${action.icon} mr-2`}
                    />
                  )}
                </Button>
              ))}
          </GridItemFooter>
        ) : null}
      </GridItemContainer>
    );
  }

  return (
    <GridItemContainer
      title="grid-item"
      onClick={onClick}
      tabIndex={0}
      className="card-organization my-5"
    >
      {data.image && (
        <GridItemHeader className="card-organization-image-container">
          <img src={data.image} alt={data.title} />
        </GridItemHeader>
      )}
      <GridItemBody className="card-body">
        <Title className="card-title">{data.title}</Title>
        <Subtitle className="card-text">{data.subtitle}</Subtitle>
        <Paragraph className="card-message">{data.message}</Paragraph>
      </GridItemBody>
      {actions && actions.length > 0 ? (
        <GridItemFooter className="card-footer">
          {actions.length > 0 &&
            actions.map((action) => (
              <Button
                key={action.label}
                className={`btn ${action.variant || "primary"}`}
                onClick={() => action.onClick(data)}
              >
                {action.label}
                {action.icon && (
                  <i title="button-icon" className={`cl ${action.icon} mr-2`} />
                )}
              </Button>
            ))}
        </GridItemFooter>
      ) : null}
    </GridItemContainer>
  );
};

GridItem.Container = GridItemContainer;
GridItem.Header = GridItemHeader;
GridItem.Body = GridItemBody;
GridItem.Footer = GridItemFooter;

export default GridItem;
